// import dama from "/modules/dama.js";
// import apiDrupal from "./api.js";
// const dm = new dama();

import * as AOS from 'aos';


// const api = new apiDrupal();
export const page = async () => {
    /* ON LOAD */
    AOS.init({
        once: true,
    });

    if (typeof localStorage.getItem('ageGateValidate') != 'string') {
        var target = document.body;
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation: any) {
                if (!mutation.target.classList.contains('agegate-visible')) {
                    AOS.refreshHard()
                }

            });
        });

        // Configura el observer:
        var config = { attributes: true, childList: true, characterData: true };

        // pasa al observer el nodo y la configuracion
        observer.observe(target, config);
    }
}